(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    const initUgcRow = (row) => {
      if (!row || row.dataset.ugcInitialized === 'true') return;
      row.dataset.ugcInitialized = 'true';

      const status = row.querySelector('[role="status"]');
      const block = row.closest('.ugc-buy-block');
      const prev = block ? block.querySelector('[data-ugc-prev]') : null;
      const next = block ? block.querySelector('[data-ugc-next]') : null;

      row.querySelectorAll('.ugc-buy__card').forEach((card) => {
        const video = card.querySelector('video');
        const button = card.querySelector('button');
        if (!video || !button) return;

        let pending = false;

        const sync = () => {
          const playing = !video.paused && !video.ended;
          card.classList.toggle('is-playing', playing);
          button.setAttribute('aria-label', playing ? button.dataset.pause : button.dataset.play);
        };

        video.addEventListener('play', () => {
          document.querySelectorAll('ugc-buy-row video').forEach((other) => {
            if (other !== video) other.pause();
          });
          sync();
        });

        video.addEventListener('pause', sync);
        video.addEventListener('ended', sync);

        button.addEventListener('click', async () => {
          if (!video.paused) {
            video.pause();
            return;
          }

          if (pending) return;
          pending = true;
          if (status) status.textContent = '';

          if (!video.getAttribute('src')) video.src = video.dataset.src;

          try {
            await video.play();
          } catch (error) {
            if (error.name !== 'AbortError' && status) status.textContent = status.dataset.error;
          } finally {
            pending = false;
            sync();
          }
        });
      });

      const getStep = () => {
        const card = row.querySelector('.ugc-buy__card, .ugc-buy__empty');
        if (!card) return row.clientWidth * 0.75;
        const gap = parseFloat(getComputedStyle(row).columnGap || getComputedStyle(row).gap || 10) || 10;
        return card.getBoundingClientRect().width + gap;
      };

      const updateNav = () => {
        if (!block) return;
        const canScroll = row.scrollWidth > row.clientWidth + 2;
        block.classList.toggle('ugc-buy-block--can-scroll', canScroll);
        if (prev) prev.disabled = !canScroll || row.scrollLeft <= 2;
        if (next) next.disabled = !canScroll || row.scrollLeft + row.clientWidth >= row.scrollWidth - 2;
      };

      if (prev) prev.addEventListener('click', () => row.scrollBy({ left: -getStep(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => row.scrollBy({ left: getStep(), behavior: 'smooth' }));

      let scrollFrame = 0;
      row.addEventListener('scroll', () => {
        cancelAnimationFrame(scrollFrame);
        scrollFrame = requestAnimationFrame(updateNav);
      }, { passive: true });

      window.addEventListener('resize', updateNav, { passive: true });
      requestAnimationFrame(updateNav);
    };

    if (!customElements.get('ugc-buy-row')) {
      customElements.define('ugc-buy-row', class extends HTMLElement {
        connectedCallback() {
          initUgcRow(this);
        }

        disconnectedCallback() {
          this.querySelectorAll('video').forEach((video) => video.pause());
        }
      });
    } else {
      document.querySelectorAll('ugc-buy-row').forEach(initUgcRow);
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ugc-video-row')) {
    customElements.define('ugc-video-row', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const status = this.querySelector('[role="status"]');
        this.querySelectorAll('.ugc-row__card').forEach(card => {
          const video = card.querySelector('video');
          const button = card.querySelector('button');
          let pending = false;
          const sync = () => {
            const playing = !video.paused && !video.ended;
            card.classList.toggle('is-playing', playing);
            button.setAttribute('aria-label', playing ? button.dataset.pause : button.dataset.play);
          };
          video.addEventListener('play', () => {
            document.querySelectorAll('ugc-video-row video').forEach(other => {
              if (other !== video) other.pause();
            });
            sync();
          });
          video.addEventListener('pause', sync);
          video.addEventListener('ended', sync);
          button.addEventListener('click', async () => {
            if (!video.paused) {
              video.pause();
              return;
            }
            if (pending) return;
            pending = true;
            status.textContent = '';
            if (!video.getAttribute('src')) video.src = video.dataset.src;
            try {
              await video.play();
            } catch (error) {
              if (error.name !== 'AbortError') status.textContent = status.dataset.error;
            } finally {
              pending = false;
              sync();
            }
          });
        });
      }
      disconnectedCallback() {
        this.querySelectorAll('video').forEach(video => video.pause());
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
